import {useDoctorList, useSendScan} from 'hooks/useScan';
import {SendScanToDoctor} from './SendScanToDoctor';
import Grid from '@mui/material/Grid';
import styles from 'assets/css/scanListModal.module.css';
import {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import {Box, Dialog, styled} from '@mui/material';

const CustomizedDialog = styled(Dialog)`
  & .MuiDialog-paper {
    display: grid;
    place-items: center;
    width: 320px !important;
    height: 300px !important;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    padding: 0 12px 0;
  }

  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }

  & .MuiDialogContent-root {
    padding: 0;
  }
`;

const DoctorListItem = ({
  firstName,
  lastName,
  phoneNumber,
  index,
  isActive,
  setActiveDoctorId,
  setDisable,
}) => {
  const selectDoctor = () => {
    setActiveDoctorId(index);
    setDisable(false);
  };

  return (
    <Grid
      container
      className={isActive ? styles.activeWrapper : styles.itemWrapper}
      key={index}
      onClick={selectDoctor}>
      <Grid className={styles.doctorName} item xs={5}>
        {firstName} {lastName}
      </Grid>
      <Grid item className={styles.centerContainer} xs={7}>
        <span className={styles.phoneNum}>شماره موبایل:</span>
        <span className={styles.phoneNumData}>{phoneNumber}</span>
      </Grid>
    </Grid>
  );
};
export const DoctorList = (props) => {
  const {
    setOpen,
    deviceDate,
    nfcData,
    reportSucceed,
    reportFailed,
    registerNewUser,
    resetHandler,
  } = props;
  const [closedClicked, setClosedClicked] = useState(null);

  const [activeDoctorId, setActiveDoctorId] = useState(null);
  const [activeSendDoctor, setActiveSendDoctor] = useState(false);
  const [disable, setDisable] = useState(true);
  const [successfullySend, setSuccessfullySend] = useState(null);
  const {mutate, isLoading} = useSendScan();
  const {data} = useDoctorList();

  useEffect(() => {
    if (data?.length === 1) {
      setActiveDoctorId(0);
      buttonSendClicked(0);
    }
  }, [data]);

  const buttonSendClicked = (activeDoctorId) => {
    const selectedDoctor = data?.find(
      (item, index) => index === activeDoctorId
    );
    if (!selectedDoctor || !nfcData || !deviceDate) return;

    let formData = new FormData();
    // const nfcData = fakeNfc
    formData.append('Data', nfcData);
    formData.append('AssistantMappingId', selectedDoctor.id);
    formData.append('DeviceDate', deviceDate?.toString());

    mutate({
      formData,
      setSuccessfullySend,
      activeDoctorId,
      reportSucceed,
      reportFailed,
      registerNewUser,
      setOpen,
    });
    setActiveSendDoctor(true);
  };

  if (closedClicked) {
    return (
      <CustomizedDialog
        open={true}
        // onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'>
        <Box
          sx={{
            width: '100%',
            display: 'grid',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <p
            style={{
              color: '#D81D5D',
              fontSize: '16px',
              fontFamily: 'dana-bold',
              textAlign: 'center',
            }}>
            لغو ثبت نام
          </p>
          <p
            style={{
              fontSize: '14px',
              fontFamily: 'dana-bold',
              color: '#707070',
              margin: '50px auto',
              textAlign: 'center',
              lineHeight: '28px',
            }}>
            با انصراف، ثبت نام بیمار لغو می شود،
            <br /> آیا از انصراف اطمینان دارید؟
          </p>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Button
              sx={{
                border: '1px solid #FFFFFF',
                width: '138px',
                borderRadius: '16px',
                boxShadow:
                  '6px 6px 30px 0px #AEAEC066,-6px -6px 30px 0px #FFFFFF',
                color: '#D81D5D',
                fontFamily: 'dana-bold',
                fontSize: '14px',
                ml: '20px',
              }}
              onClick={() => {
                resetHandler();
                setOpen(false);
              }}>
              بله
            </Button>
            <Button
              sx={{
                border: '1px solid #FFFFFF',
                width: '138px',
                borderRadius: '16px',
                boxShadow:
                  '6px 6px 30px 0px #AEAEC066,-6px -6px 30px 0px #FFFFFF',
                color: '#753CBE',
                fontFamily: 'dana-bold',
                fontSize: '14px',
              }}
              onClick={() => setClosedClicked(false)}>
              خیر
            </Button>
          </Box>
        </Box>
      </CustomizedDialog>
    );
  }

  return (
    <Grid container>
      {activeSendDoctor && (
        <SendScanToDoctor
          retryHandler={buttonSendClicked}
          successHandler={() => setOpen(false)}
          activeDoctorId={activeDoctorId}
          isLoading={isLoading}
          successfullySend={successfullySend}
        />
      )}
      {!activeSendDoctor && (
        <>
          <p className={styles.title}>لیست پزشکان شما</p>
          <p className={styles.subTitle}>
            پزشک مورد نظر خود را انتخاب کنید و اسکن رابرای او <br />
            ارسال کنید
          </p>
          <Grid container>
            {data?.map((item, index) => {
              let isActive = index === activeDoctorId;
              return (
                <DoctorListItem
                  index={index}
                  firstName={item?.doctor?.firstName}
                  lastName={item?.doctor?.lastName}
                  phoneNumber={item?.doctor?.phoneNumber}
                  isActive={isActive}
                  setActiveDoctorId={setActiveDoctorId}
                  setDisable={setDisable}
                />
              );
            })}
          </Grid>
          <Grid className={styles.mainContainer}>
            <Grid item xs={6} className={styles.centerContainer}>
              <Button
                disabled={disable}
                onClick={() => buttonSendClicked(activeDoctorId)}
                className={`${styles.registerButton} ${
                  disable && styles.disableStyle
                }`}>
                ارسال برای پزشک
              </Button>
            </Grid>
            <Grid item xs={6} className={styles.centerContainer}>
              <Button
                onClick={() => {
                  setClosedClicked(true);
                }}
                className={`${styles.cancelButton} `}>
                انصراف
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
